export default {
  title: 'Gift Categories',
  addFirstLevel: 'Add Category',
  addSecondLevel: 'Add Sub-category',
  categoryName: 'Category Name',
  addModal: 'Add Category',
  editModal: 'Edit Category',
  addSecondModal: 'Add Sub-category',
  required: 'Please enter category name',
};
